export default {
  value: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    default: () => String(''),
  },
  title: {
    type: String,
    default: () => String('KPI'),
  },
  countriesList: {
    // @ts-ignore - this props will be imported into VueConstructor, where it's valid syntax
    type: Object | null,
  },
  ...[
    'languagesList',
    'qaMethodsList',
    'qaModelsList',
    'textCategoryList',
    'industryFieldList',
  ].reduce((acc, key) => {
    acc[key] = {
      type: Array,
      required: true,
    };
    return acc;
  }, Object()),
};
